// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Blle","description":"styles_description__ieIhM","content":"styles_content__6Ytvm","item":"styles_item__2ITBM","icon":"styles_icon__1otl0"};